import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'


const TabelaAnosSobras = ({
    anosSobras,
    anoSobra,
    setAnoSobra
}) => {

    function onChangeAnoSobra(ano) {
        setAnoSobra(ano);
    }

    const linhasTabelaAnosSobras = anosSobras.map((ano, index) => {
        return <tr key={index}>
            <td className="text-start">{ano}</td>
            <td className="text-end">
                {/* <Button className="botao-imprimir" onClick={() => onChangeAnoSobra(ano)}> */}
                    <FontAwesomeIcon className="botao-imprimir" icon={faPrint} onClick={() => onChangeAnoSobra(ano)}/>
                {/* </Button> */}
            </td>
        </tr>
    });

    return (
        // <div className="justify-content-center">
            <div className="col-sm-8 col-md-6">
                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead >
                            <tr className=" green-text">
                                <th className="text-start">Ano Sobras</th>
                                <th className="text-end">Imprimir</th>
                            </tr>
                        </thead>
                        <tbody>
                            {linhasTabelaAnosSobras}
                        </tbody>
                    </table>
                </div>
            </div>
        // </div>
    )
}

export default TabelaAnosSobras;